import CommonService from "../../../services/commonService";

let headerLinks = {
	// Themes 5
	tepual: [
		{ label: 'Compra tu pasaje', url: '/' },
		{ label: 'Destinos', url: '/destinos' },
		{ label: 'Nosotros', url: '/about-us' },
		{ label: 'Términos y Condiciones', url: '/terms' },
		{ label: 'Oficinas', url: '/office' },
		{ label: 'Galeria', url: '/gallery' },
		{ label: 'Contacto', url: '/contact' },
	],

	saopaulo: [
		{ label: 'Compra tu pasaje', url: '/' },
		{ label: 'Destinos', url: '/saopaulo-destinos' },
		{ label: 'La empresa', url: '/about-saopaulo' },
		{ label: 'Oficinas', url: '/saopaulo-office' },
		{ label: 'Términos y Condiciones', url: '/saopaulo-terms' },
		{ label: 'Contacto', url: '/saopaulo-contact' },

	],
	santajuana: [
		{ label: 'Inicio', url: '/' },
		{ label: 'Trabaja con nosotros', url: '/juana-work' },
		{ label: 'La empresa', url: '/about-santajuana' },
		{ label: 'Oficinas', url: '/santajuana-office' },
		// { label: 'Términos y Condiciones', url: '/santajuana-terms' },
		{ label: 'Contacto', url: '/santajuana-contact' },
	],


	viatur: [
		{ label: 'Destinos', url: '/#buses' },
		{ label: 'La empresa', url: '/#features' },
		{ label: 'Oficinas', url: '/#office' },
		{ label: 'Galeria', url: '/#gallery' },
		{ label: 'Contacto', url: '/#contact' },
	],

	kennybus: [
		{ label: 'Destinos', url: '/#buses' },
		{ label: 'La empresa', url: '/#features' },
		{ label: 'Oficinas', url: '/#office' },
		{ label: 'Obligaciones de los pasajeros', url: '/#passenger' },
		{ label: 'Contacto', url: '/#contact' },
	],
	santamaria: [
		{ label: 'Destinos', url: '/#buses' },
		{ label: 'La empresa', url: '/#features' },
		{ label: 'Oficinas', url: '/#office' },
		{ label: 'Términos y condiciones', url: '/#terms' },
		{ label: 'Contacto', url: '/#contact' },
	],
	biaggini: [
		{ label: 'Nuestros destinos', url: '/#buses' },
		{ label: 'Quiénes somos', url: '/#About us' },
		{ label: 'Oficinas', url: '/#office' },
		{ label: 'Términos y condiciones', url: '/#terms' },
		{ label: 'Contacto', url: '/#contact' },
	]

}



const getHeaderLinks = () => {
	const operator = CommonService.getLocal('op');
	const name = operator && operator.operator_name ? operator.operator_name : ''
	let data = headerLinks[name]
	// console.log({ data }, 'data--------------------')
	return data ? data : []
}

export default getHeaderLinks


// WEBPACK FOOTER //
// ./src/features/themes/functions/getHeaderLinks.js